module.exports = __webpack_public_path__ + "assets/b77605416a05839e198adc41e02b5e27.png";